import { Component } from '@angular/core';

@Component({
  selector: 'contactus-component',
  styles: [`
    agm-map {
      height: 500px;
    }
  `],
  templateUrl: './contactus.tpl.html'
})
export class ContactusComponent {
  lat: number =17.621007;
  lng: number = 83.081062;
  label: string = 'Rainbow';

}



// WEBPACK FOOTER //
// ./src/app/contact_us/contactus.component.ts